import { render, staticRenderFns } from "./user-admin.vue?vue&type=template&id=a04adaa0&"
import script from "./user-admin.vue?vue&type=script&lang=js&"
export * from "./user-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports